import { render, staticRenderFns } from "./CompanyTile.vue?vue&type=template&id=98522e54&scoped=true&lang=pug"
import script from "./CompanyTile.vue?vue&type=script&lang=ts"
export * from "./CompanyTile.vue?vue&type=script&lang=ts"
import style0 from "./CompanyTile.vue?vue&type=style&index=0&id=98522e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98522e54",
  null
  
)

/* custom blocks */
import block0 from "@locales/de/de.yml?namespace=ui.shared.go_to?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fcompanies%2FCompanyTile.vue&locale=de&lang=yaml&external"
if (typeof block0 === 'function') block0(component)
import block1 from "@locales/en/en.yml?namespace=ui.shared.go_to?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuild%2Ffrontend%2Fcomponents%2Fcompanies%2FCompanyTile.vue&locale=en&lang=yaml&external"
if (typeof block1 === 'function') block1(component)

export default component.exports